/**
 * Checks if a password is ok. if not, it'll return a string
 * @returns `undefined` if criteria is met. Otherwise `string` containing a NON-translated error.
 */
export default function passwordValidate(password:string){
  if((/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).{8,}$/g).test(password)) return 
  else return "invalidPasswordValidation"
}